import React, { useState } from 'react';
import { LogOut, Mic, FileImage, FileText } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { TranscriptionFull } from '../components/TranscriptionFull';
import { ImageOCR } from '../components/ImageOCR';
import { AnamneseGenerator } from '../components/AnamneseGenerator';

const Dashboard = () => {
  const [activeTool, setActiveTool] = useState('transcription');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { logout } = useAuth();

  const tools = [
    { id: 'transcription', name: 'Transcrição', icon: Mic, Component: TranscriptionFull },
    { id: 'ocr', name: 'OCR Imagem', icon: FileImage, Component: ImageOCR },
    { id: 'anamnese', name: 'Anamnese IA', icon: FileText, Component: AnamneseGenerator },
  ];

  const ActiveComponent = tools.find(t => t.id === activeTool)?.Component;

  return (
    <div className="dashboard">
      {/* Botão de menu para mobile */}
      <button className="mobile-menu-button" onClick={() => setIsSidebarOpen(true)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>

      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="logo">🏥</div>

        <nav>
          {tools.map((tool) => {
            const Icon = tool.icon;
            return (
              <button
                key={tool.id}
                className={activeTool === tool.id ? 'active' : ''}
                onClick={() => {
                  setActiveTool(tool.id);
                  setIsSidebarOpen(false); // Fecha o menu ao selecionar
                }}
              >
                <Icon size={20} />
                <span>{tool.name}</span>
              </button>
            );
          })}
        </nav>

        <button className="logout" onClick={logout}>
          <LogOut size={20} />
          <span>Sair</span>
        </button>
      </aside>

      {/* Overlay escuro ao fundo do drawer */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>}

      {/* Conteúdo principal */}
      <main className={`content ${isSidebarOpen ? 'shifted' : ''}`}>
        {ActiveComponent && <ActiveComponent />}
      </main>
    </div>
  );
};

export default Dashboard;
